import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Text, TEXT_VARIANTS } from 'ui/Typography';

import zendeskLogo from 'images/zendesk_logo.png';
import zendeskEnvelope from 'images/zendesk_envelope.svg';
import userZendeskDark from 'images/user_zendesk_dark.svg';
import userZendeskLight from 'images/user_zendesk_light.svg';

const ZendeskInfo = props => {
  const {
    data,
    meta,
    handleReplyChange,
    message,
    isViewAnswer = false,
    answer = {},
    isDisabled,
  } = props;
  const createdAt = isViewAnswer
    ? answer.created_at
    : data.zendeskTicket.created_at;
  const name = isViewAnswer
    ? data.requester
    : data.zendeskTicket.requester_name;
  const ticketBody = isViewAnswer ? data.body : data.zendeskTicket.description;
  const sentTime = moment(createdAt).format('MMM DD HH:mm');
  const requesterName =
    name ||
    t('questions.question.ticket_handling.zendesk.default_metadata.from');
  const ticketMessage =
    ticketBody || t('questions.question.ticket_handling.default_metadata.body');
  const ticketSubject = isViewAnswer
    ? data.subject
    : data.zendeskTicket.subject;
  const messageToDisplay = () => {
    if (isViewAnswer) return answer.given_answer.message;
    return meta.previewing ? '' : message;
  };
  return (
    <div className="ZendeskPracticeQuestion-window">
      <div className="ZendeskPracticeQuestion-windowHeader d-f jc-c ai-c pos-r">
        <div className="ZendeskPracticeQuestion-headerButtonContainer d-f pos-a">
          <div className="ZendeskPracticeQuestion-headerFakeButton" />
          <div className="ZendeskPracticeQuestion-headerFakeButton" />
          <div className="ZendeskPracticeQuestion-headerFakeButton" />
        </div>
        <Text
          className="ZendeskPracticeQuestion-headerText"
          variant={TEXT_VARIANTS.BODY}
        >
          {t(
            'questions.question.ticket_handling.zendesk.zendesk_support_practice',
          )}
        </Text>
      </div>
      <div className="ZendeskPracticeQuestion-windowMain">
        <div className="ZendeskPracticeQuestion-sidebar">
          <div className="ZendeskPracticeQuestion-logoContainer d-f jc-c ai-c">
            <img src={zendeskLogo} alt="Zendesk Support Logo" />
          </div>
        </div>
        <div className="ZendeskPracticeQuestion-ticket">
          <div className="ZendeskPracticeQuestion-ticketDataSection">
            <div className="ZendeskPracticeQuestion-sentTicketIcon">
              <img src={zendeskEnvelope} alt="envelope icon" />
            </div>
            <div className="ZendeskPracticeQuestion-ticketData d-f fd-c">
              <Text variant={TEXT_VARIANTS.BODY_BOLD} enableTheme={false}>
                {ticketSubject ||
                  t(
                    'questions.question.ticket_handling.default_metadata.subject',
                  )}
              </Text>
              <Text
                className="ZendeskPracticeQuestion-ticketDataSubtitle"
                variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                enableTheme={false}
              >
                <>
                  {sentTime !== 'Invalid date' && `${sentTime} • `}
                  {requesterName}
                </>
              </Text>
            </div>
          </div>
          <div className="ZendeskPracticeQuestion-ticketReplySection">
            <div
              className="ZendeskPracticeQuestion-companyLogoIcon"
              style={{ backgroundImage: `url(${data.companyLogo})` }}
            >
              <div className="ZendeskPracticeQuestion-userReplyIcon">
                <img src={userZendeskDark} alt="user icon" />
              </div>
            </div>
            <div className="ZendeskPracticeQuestion-ticketReply">
              <Text
                className="ZendeskPracticeQuestion-ticketReplyHeading"
                variant={TEXT_VARIANTS.BODY_BOLD}
                enableTheme={false}
              >
                {t('questions.question.ticket_handling.zendesk.public_reply')}
              </Text>
              <textarea
                className="ZendeskPracticeQuestion-ticketReplyInput"
                disabled={isDisabled}
                onChange={handleReplyChange}
                value={messageToDisplay()}
              />
            </div>
          </div>
          <div className="ZendeskPracticeQuestion-ticketMessageSection">
            <div className="ZendeskPracticeQuestion-userSentIcon">
              <img src={userZendeskLight} alt="user icon" />
            </div>
            <div className="ZendeskPracticeQuestion-ticketMessage">
              <div className="ZendeskPracticeQuestion d-f ai-c mb-4">
                <Text
                  className="ZendeskPracticeQuestion-senderName mr-4"
                  variant={TEXT_VARIANTS.BODY_BOLD}
                  enableTheme={false}
                >
                  {requesterName}
                </Text>
                {sentTime !== 'Invalid date' && (
                  <Text
                    className="ZendeskPracticeQuestion-sentTime"
                    variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
                    enableTheme={false}
                  >
                    {sentTime}
                  </Text>
                )}
              </div>
              <Text
                className="ZendeskPracticeQuestion-ticketMessageText ws-pr"
                variant={TEXT_VARIANTS.BODY_LIGHT}
                enableTheme={false}
              >
                {ticketMessage}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ZendeskInfo.propTypes = {
  data: PropTypes.shape({
    zendeskTicket: PropTypes.shape({
      created_at: PropTypes.string,
      requester_name: PropTypes.string,
      description: PropTypes.string,
      subject: PropTypes.string,
    }),
    requester: PropTypes.string,
    body: PropTypes.string,
    subject: PropTypes.string,
  }),
  meta: PropTypes.shape({
    previewing: PropTypes.bool,
  }),
  handleReplyChange: PropTypes.func,
  message: PropTypes.string,
  isViewAnswer: PropTypes.bool,
  answer: PropTypes.shape({
    created_at: PropTypes.string,
    given_answer: PropTypes.shape({
      message: PropTypes.string,
    }),
  }),
  isDisabled: PropTypes.bool,
};

export default ZendeskInfo;
